module.exports = __webpack_public_path__ + "img/no-imgs.7acd705b.jpg";